export default "__VITE_ASSET__3060949e__"